import React, { useState } from 'react';
import { IdView, Typography } from '../../../../components';
import { PartnerOrderData } from '../types';
import { Icon } from '@iconify/react';
import EditCampaignModal from './EditCampaignModal';
import { CampaignEditData } from './EditCampaignModal';

interface OrderIdCellProps {
  order: PartnerOrderData;
}

const OrderIdCell: React.FC<OrderIdCellProps> = ({ order }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // Извлекаем ID кампании из ссылки (код после последнего слеша)
  const campaignId = order.campaign.link?.split('/').filter(Boolean).pop() || '';

  // Показываем ID кампании и кнопку редактирования только для активных или завершенных заказов
  const showCampaignDetails = order.status === 'in_progress' || order.status === 'completed';

  const handleSaveCampaign = (data: CampaignEditData) => {
    // TODO: Implement API call to save campaign data
    console.log('Save campaign:', data);
  };

  return (
    <div className="flex flex-col items-start gap-1">
      <IdView textToCopy={order.id}>{order.id.slice(-4)}</IdView>

      {/* {showCampaignDetails && campaignId && (
        <div className="flex items-center gap-2">
          <Typography variant="body3" className="text-auth-muted">
            {campaignId}
          </Typography>
          <button
            onClick={() => setIsEditModalOpen(true)}
            className="flex items-center justify-center hover:opacity-70 transition-opacity"
          >
            <Icon 
              icon="solar:settings-linear" 
              width={16} 
              height={16} 
              className="text-partner" 
            />
          </button>
        </div>
      )} */}

      <EditCampaignModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        order={order}
        onSave={handleSaveCampaign}
      />
    </div>
  );
};

export default OrderIdCell;
